// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"up-z","selected":"vp-z"};